<div class="carousel-wrapper" *transloco="let t">

  @if (images) {
    <ngb-carousel [showNavigationIndicators]="false" [showNavigationArrows]="false">
      @for (image of images;track image) {
        <ng-template ngbSlide>
          <div class="slide">
            <img [src]="image" [alt]="imageAlt"/>
          </div>
        </ng-template>
      }
    </ngb-carousel>
  }
  @if (showGradient) {
    <div class="linear-gradient"></div>
  }
  <div class="container carousel-content">
    @if (bannerImage) {
      <div class="carousel-content__banner">
        <img [alt]="bannerAlt" [src]="bannerImage">
      </div>
    }
    @if (showButton) {
      <div class="carousel-button">
        <ng-content select="[slot='button']"></ng-content>
      </div>
    }
    <ng-content select="[slot='content']"></ng-content>
  </div>
</div>
